export default "__VITE_ASSET__CpT1Tqq3__"